import { Box, Text } from '@wix/design-system';
import type { PropsWithChildren } from 'react';
import React from 'react';

export const Section: React.FC<PropsWithChildren & { title: React.ReactNode }> = ({
  children,
  title,
}) => {
  return (
    <>
      <Box marginTop="SP2" marginBottom="SP1">
        <Text size="small" weight="bold">
          {title}
        </Text>
      </Box>
      {children}
    </>
  );
};
